import { IEtfCorrelationService, EtfCorrelationServiceImpl } from './correlations.service';

export * from './correlations.model';

export const EtfCorrelationService: IEtfCorrelationService = new EtfCorrelationServiceImpl();